import EventBus from '@/event-bus';
import clearFormMixin from '@/mixins/clearForm';

export default {
  inject: ['$validator'],
  mixins: [
    clearFormMixin,
  ],
  created() {
    EventBus.$on('update', () => {
      EventBus.$emit(this.dialogBus.closeModal);
    });
    EventBus.$on(this.dialogBus.modalOpened, (edit, clearform = null) => {
      if (!clearform) {
        this.clearForm();
      }
      if (edit) {
        this.editing = true;
      } else {
        this.editing = false;
      }
    });
    EventBus.$on(this.dialogBus.showMore, () => {
      this.more = true;
    });
    EventBus.$on(this.dialogBus.editItem, (id, changeRoute = true) => {
      if (changeRoute) {
        this.route = this.route.replace(`/${id}`, '');
        this.route += `/${id}`;
      }
      this.cancelToken = this.axios.CancelToken.source();
      this.searchElement();
    });
    EventBus.$on(this.dialogBus.closeModal, (clearformed = null) => {
      if (this.edit) {
        this.route = this.route.split('/').slice(0, this.route.split('/').length - 1).join('/');
      }
      if (clearformed != null) {
        this.clearForm();
      }
      this.edit = false;
      this.dialog = false;
    });
    EventBus.$on('formData', () => {
      this.dialog = false;
    });
  },
  destroyed() {
    EventBus.$off(this.dialogBus.created);
    EventBus.$off(this.dialogBus.modalOpened);
    EventBus.$off(this.dialogBus.showMore);
    EventBus.$off(this.dialogBus.editItem);
    EventBus.$off(this.dialogBus.closeModal);
    EventBus.$off(this.dialogBus.openRightDrawer);
  },
  data() {
    return {
      cancelToken: {},
      dialog: false,
      edit: false,
      more: false,
      editing: false,
      dialogBus: {
        created: 'created',
        updated: 'updated',
        editItem: 'editItem',
        modalOpened: 'modalOpened',
        showMore: 'showMore',
        closeModal: 'closeModal',
        openRightDrawer: 'openRightDrawer',
        elementFound: 'elementFound',
      },
    };
  },
  methods: {
    searchElement() {
      this.axios.get(`${this.route}${this.fields ? `?fields=${this.fields}` : ''}`, {
        cancelToken: this.cancelToken.token,
      }).then((response) => {
        EventBus.$emit(this.dialogBus.elementFound, response.data);
        Object.keys(this.form).forEach((key) => {
          if (key !== 'tags') {
            this.form[key] = response.data[key];
          } else {
            this.form.tags = response.data.tags.map(tag => tag.name);
          }
        });
      });
      this.edit = true;
      this.dialog = true;
    },
    openSidebarForm() {
      EventBus.$emit(this.dialogBus.openRightDrawer);
    },
  },
  computed: {
    title() {
      return `${(!this.edit ? 'Añadir' : 'Editar')} ${this.showName} ${(!this.edit ? 'nuevo' : '')}`;
    },
    hasMore() {
      return !this.edit;
    },
  },
  watch: {
    dialog(newVal) {
      if (newVal) {
        this.more = false;
      } else if (Object.keys(this.cancelToken).length) {
        this.cancelToken.cancel('');
      }
    },
    edit(newVal) {
      if (newVal) {
        this.more = true;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/saveDialog.js